import * as React from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

type InputStringListProps = {
  label: string;
  value: string[];
  helperText?: string;
  error?: boolean;
  onChange: (value: string[]) => void;
  autoFocus?: boolean;
  customWidth?: number;
  disabled?: boolean;
  hidden?: boolean;
  description?: string;
};

export const InputStringList: React.FC<InputStringListProps> = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  autoFocus = false,
  customWidth = 500,
  disabled = false,
  hidden = false,
  description,
}) => {
  if (hidden) return null;
  return (
    <Autocomplete
      disabled={disabled}
      multiple
      freeSolo
      autoSelect
      options={[]}
      value={value}
      slotProps={{
        popper: {
          sx: { zIndex: 10300 },
        },
      }}
      onChange={(_event, newValue) => {
        const filteredValues = newValue
          .filter((v) => typeof v === "string" && v.trim() !== "")
          .map((v) => v.trim());
        const uniqueValues = Array.from(new Set(filteredValues));
        onChange(uniqueValues);
      }}
      sx={{ m: 1, width: customWidth }}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          size={"small"}
          inputProps={{ ...params.inputProps, autoComplete: "one-time-code" }}
          error={error}
          helperText={helperText}
          label={<FieldLabelWithHelp label={label} description={description} />}
          InputLabelProps={description ? { shrink: true } : undefined}
        />
      )}
    />
  );
};
